export default "__VITE_ASSET__BeUs$DAz__"